import { render, staticRenderFns } from "./Ceparium.vue?vue&type=template&id=648bd864&scoped=true&"
import script from "./Ceparium.vue?vue&type=script&lang=js&"
export * from "./Ceparium.vue?vue&type=script&lang=js&"
import style0 from "./Ceparium.vue?vue&type=style&index=0&id=648bd864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648bd864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
